module.exports = __webpack_public_path__ + "static/media/sicherung_loesung.5af0f4f7.jpg";